import { render, staticRenderFns } from "./CookieStatement.vue?vue&type=template&id=4904fa53&"
import script from "./CookieStatement.vue?vue&type=script&lang=js&"
export * from "./CookieStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports